import { useEffect, useState } from "react";
import useIntersectionObserver from "./useIntersectionObserver";

export default function useCountUp(target, { duration = 1600, start = 0, decimals = 0, suffix = "" } = {}) {
  const [ref, inView] = useIntersectionObserver({ threshold: 0.3, once: true });
  const [value, setValue] = useState(start);

  useEffect(() => {
    if (!inView) return;
    const startTime = performance.now();
    let raf;

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(start + (target - start) * eased);
      if (progress < 1) raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target, duration, start]);

  const display =
    decimals > 0
      ? value.toFixed(decimals) + suffix
      : Math.floor(value).toLocaleString() + suffix;

  return [ref, display];
}
